export default "__VITE_ASSET__DYeJ77Jp__"